import React, { useState } from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';

import { images } from '../../constants';
import './Navbar.scss';

const NAV_ITEMS = [
  { id: 'home', label: 'Home' },
  { id: 'project', label: 'Work' },
  { id: 'experience', label: 'Skills' },
  { id: 'education', label: 'Education' },
];

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  const desktopItems = NAV_ITEMS;
  const mobileItems = [...NAV_ITEMS, { id: 'contact', label: 'Contact' }];

  return (
    <nav className="app__navbar">
      <a href="#home" className="app__navbar-logo" aria-label="Go to home">
        <img src={images.logo} alt="logo" />
      </a>

      <ul className="app__navbar-links">
        {desktopItems.map(({ id, label }) => (
          <li className="app__flex p-text" key={`link-${id}`}>
            <div />
            <a href={`#${id}`} onClick={() => setToggle(false)}>
              {label}
            </a>
          </li>
        ))}
      </ul>

      <a href="#contact" className="nav-btn">Contact</a>

      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: 'easeOut' }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {mobileItems.map(({ id, label }) => (
                <li key={id}>
                  <a href={`#${id}`} onClick={() => setToggle(false)}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;